import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const navigate = useNavigate();

  const poll = useCallback(async (sessionId, attempt = 0) => {
    if (attempt >= 6) { setStatus("timeout"); return; }
    try {
      const { data } = await api.get(`/payments/status/${sessionId}`);
      setInfo(data);
      if (data.payment_status === "paid") { setStatus("paid"); return; }
      if (data.status === "expired") { setStatus("expired"); return; }
      setTimeout(() => poll(sessionId, attempt + 1), 2000);
    } catch {
      setTimeout(() => poll(sessionId, attempt + 1), 2000);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get("session_id");
    if (sid) poll(sid); else setStatus("timeout");
  }, [poll]);

  const back = info?.kind === "lead" ? "/espace-poseur" : "/espace-client";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#F1F5F9] p-6 text-center">
      {status === "checking" && (<><Loader2 className="h-12 w-12 animate-spin text-[#1D9BF0]" /><p className="mt-4 text-slate-600">Vérification du paiement…</p></>)}
      {status === "paid" && (<>
        <CheckCircle2 className="h-16 w-16 text-emerald-500" />
        <h1 className="mt-4 text-2xl font-bold text-[#263871]">Paiement confirmé !</h1>
        <p className="mt-2 text-slate-600">Merci, votre transaction a bien été enregistrée.</p>
        <Button onClick={() => navigate(back)} className="mt-6 rounded-full bg-[#263871] px-8">Retour à mon espace</Button>
      </>)}
      {(status === "timeout" || status === "expired") && (<>
        <XCircle className="h-16 w-16 text-amber-500" />
        <h1 className="mt-4 text-2xl font-bold text-[#263871]">Paiement en attente</h1>
        <p className="mt-2 text-slate-600">Le statut n'a pas pu être confirmé. Consultez votre espace.</p>
        <Button onClick={() => navigate(back)} className="mt-6 rounded-full bg-[#263871] px-8">Mon espace</Button>
      </>)}
    </div>
  );
}
